/**
 * Adressvorschläge beim Tippen (PARITAET-14, im Altportal über photon.komoot.io). Entscheidung: standardmäßig AUS, damit keine
 * Adressdaten ohne Vertrag an einen fremden Dienst gehen. Einschalten per Build-Variable VITE_ADDRESS_SEARCH_URL mit einem
 * Dienst, der die Photon-Schnittstelle spricht (selbst betrieben oder ein EU-Anbieter mit Auftragsverarbeitungsvertrag),
 * z. B. „https://geo.example.com“. Der Dienst bekommt nur den getippten Text (keine Namen, keine Kennungen). Fällt er aus,
 * bleibt das Feld ein normales Textfeld (kein Fehler). Ohne Abhängigkeit von React, damit die Tests die Regeln prüfen.
 */

export interface AddressHit { label: string; street: string; postal_code: string; city: string; country: string | null }

/** Adresse des Dienstes aus der Build-Variable; leer oder kein https (außer lokal) = aus */
export function addressSearchBase(raw: string | undefined | null): string | null {
  const v = (raw ?? "").trim().replace(/\/+$/, "");
  if (!v) return null;
  return /^https:\/\//.test(v) || /^http:\/\/(127\.0\.0\.1|localhost)(:\d+)?$/.test(v) ? v : null;
}

/** Anfrage erst ab vier Zeichen und nie mit E-Mail-Adressen oder reinen Zahlen */
export function addressQuery(base: string, text: string, lang: "de" | "en" = "de"): string | null {
  const q = text.trim().replace(/\s+/g, " ");
  if (q.length < 4 || q.length > 120 || q.includes("@") || /^\d+$/.test(q)) return null;
  return `${base}/api/?q=${encodeURIComponent(q)}&limit=5&lang=${lang}&layer=house&layer=street`;
}

/** Antwort im Photon-Format (GeoJSON) → Vorschläge; Unvollständiges wird ausgelassen */
export function photonHits(json: unknown): AddressHit[] {
  const features = (json as { features?: unknown[] } | null)?.features;
  if (!Array.isArray(features)) return [];
  const out: AddressHit[] = [];
  for (const f of features) {
    const p = (f as { properties?: Record<string, unknown> } | null)?.properties ?? {};
    const str = (k: string) => (typeof p[k] === "string" ? (p[k] as string).trim() : "");
    const road = str("street") || (str("type") === "street" ? str("name") : "");
    const street = [road, str("housenumber")].filter(Boolean).join(" ");
    const city = str("city") || str("town") || str("village") || str("district");
    const postal = str("postcode");
    if (!street || !city) continue;
    const cc = str("countrycode").toUpperCase();
    const hit = { label: [street, [postal, city].filter(Boolean).join(" "), cc].filter(Boolean).join(", "), street, postal_code: postal, city, country: /^[A-Z]{2}$/.test(cc) ? cc : null };
    if (!out.some((x) => x.label === hit.label)) out.push(hit);
  }
  return out;
}
